import { injectDispatch, injectSelector } from '@reduxjs/angular-redux';
import { AppDispatch, RootState } from './create-store';

// Use throughout your app instead of plain `injectDispatch` and `injectSelector`
export const dispatch = injectDispatch.withTypes<AppDispatch>();
export const select = injectSelector.withTypes<RootState>();
